import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AchEnrollmentEffects } from './effects/ach-enrollment.effects';
import { reducer } from './reducers/ach-enrollment.reducer';
import {
    achEnrollmentFeatureKey,
    AchEnrollmentSelectors,
} from './selectors/ach-enrollment.selectors';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(achEnrollmentFeatureKey, reducer),
        EffectsModule.forFeature([AchEnrollmentEffects]),
    ],
    exports: [EffectsModule, StoreModule],
    providers: [AchEnrollmentSelectors],
    declarations: [],
})
export class AchEnrollmentStoreModule {}
